var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15.8359H13.1719C14.0625 15.8359 14.7448 15.599 15.2188 15.125C15.6927 14.6562 15.9297 13.9792 15.9297 13.0938V3.64062C15.9297 2.75521 15.6927 2.07812 15.2188 1.60938C14.7448 1.13542 14.0625 0.898438 13.1719 0.898438H3.75C2.85938 0.898438 2.17708 1.13542 1.70312 1.60938C1.22917 2.07812 0.992188 2.75521 0.992188 3.64062V13.0938C0.992188 13.9792 1.22917 14.6562 1.70312 15.125C2.17708 15.599 2.85938 15.8359 3.75 15.8359ZM8.05469 11.4141L5.28125 6.67188C5.17708 6.48958 5.16667 6.30469 5.25 6.11719C5.33333 5.92448 5.47656 5.82812 5.67969 5.82812H11.3438C11.5521 5.82812 11.6953 5.92188 11.7734 6.10938C11.8568 6.29688 11.8438 6.48438 11.7344 6.67188L8.98438 11.4141C8.88021 11.5911 8.72396 11.6797 8.51562 11.6797C8.30729 11.6745 8.15365 11.5859 8.05469 11.4141Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBox);
export default __webpack_public_path__ + "static/media/arrow-down-box.72992040c2639fd2e41f0a2a71f745b1.svg";
export { ForwardRef as ReactComponent };